export default "__VITE_ASSET__CLgRoqmC__"